import React from 'react';
 
import PropTypes from 'prop-types';

import {
    Grid,
} from '@mui/material';

import { Typography } from '../../wrappers';

import CommonImages from '../../../../commons/images'
import useStyles from './styles';

function DeleteFace (props)  {
    const classes = useStyles({});
    const {
        message,
        subMessage,
        messageIcon, 

    } = props;
    

    function renderContentIcon() {
        console.log('DeleteFace.renderIcon() ', message);
        if (messageIcon) {
          return messageIcon;
        }
        return (<img src={CommonImages.ALERT_CIRCLE} alt='delete'></img>);
    }

    return (
        <Grid className={classes.defaultContent}>
            { renderContentIcon() }
            <Typography className={classes.message}>
                {message}
            </Typography>
            <Typography className={classes.subMessage}>
                {subMessage}
            </Typography>
    </Grid>
    );
}

 
DeleteFace.propTypes = {
    message: PropTypes.string,
    subMessage: PropTypes.string,
    messageIcon: PropTypes.any,
};
  
DeleteFace.defaultProps = {
    message: 'Are you sure?',
    subMessage: 'Please be aware that all publisher subscriptions will be deleted from all connected devices.',
    messageIcon: null,
};
 

export default DeleteFace;